"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FrameMarkerIcon = void 0;
var FrameMarkerIcon;
(function (FrameMarkerIcon) {
    FrameMarkerIcon["MarkerApteka"] = "markerApteka";
    FrameMarkerIcon["MarkerBankBankomat"] = "markerBankBankomat";
    FrameMarkerIcon["MarkerBank"] = "markerBank";
    FrameMarkerIcon["MarkerBoisko"] = "markerBoisko";
    FrameMarkerIcon["MarkerCentrumPrzesiadkowe"] = "markerCentrumPrzesiadkowe";
    FrameMarkerIcon["MarkerCustom"] = "markerCustom";
    FrameMarkerIcon["MarkerFitness"] = "markerFitness";
    FrameMarkerIcon["MarkerGaleriaHandlowa"] = "markerGaleriaHandlowa";
    FrameMarkerIcon["MarkerGastronomia"] = "markerGastronomia";
    FrameMarkerIcon["MarkerKawiarnia"] = "markerKawiarnia";
    FrameMarkerIcon["MarkerKino"] = "markerKino";
    FrameMarkerIcon["MarkerKosciol"] = "markerKosciol";
    FrameMarkerIcon["MarkerKultura"] = "markerKultura";
    FrameMarkerIcon["MarkerLotnisko"] = "markerLotnisko";
    FrameMarkerIcon["MarkerParkBiurowy"] = "markerParkBiurowy";
    FrameMarkerIcon["MarkerPark"] = "markerPark";
    FrameMarkerIcon["MarkerParking"] = "markerParking";
    FrameMarkerIcon["MarkerPlac"] = "markerPlac";
    FrameMarkerIcon["MarkerPoczta"] = "markerPoczta";
    FrameMarkerIcon["MarkerPrzedszkole"] = "markerPrzedszkole";
    FrameMarkerIcon["MarkerPrzystanekAutobusowy"] = "markerPrzystanekAutobusowy";
    FrameMarkerIcon["MarkerPrzystanekKolejowy"] = "markerPrzystanekKolejowy";
    FrameMarkerIcon["MarkerPrzystanekTramwajowy"] = "markerPrzystanekTramwajowy";
    FrameMarkerIcon["MarkerSklep"] = "markerSklep";
    FrameMarkerIcon["MarkerStacjaBenzynowa"] = "markerStacjaBenzynowa";
    FrameMarkerIcon["MarkerStacjaRowerowMiejskich"] = "markerStacjaRowerowMiejskich";
    FrameMarkerIcon["MarkerSzkolaPrzedszkole"] = "markerSzkolaPrzedszkole";
    FrameMarkerIcon["MarkerSzkola"] = "markerSzkola";
    FrameMarkerIcon["MarkerSzpital"] = "markerSzpital";
    FrameMarkerIcon["MarkerUniwersytetPolitechnika"] = "markerUniwersytetPolitechnika";
    FrameMarkerIcon["MarkerUrzad"] = "markerUrzad";
    FrameMarkerIcon["MarkerWeterynarz"] = "markerWeterynarz";
    FrameMarkerIcon["MarkerZdrowieUrodaRekreacja"] = "markerZdrowieUrodaRekreacja";
    FrameMarkerIcon["MarkerZlobek"] = "markerZlobek";
    FrameMarkerIcon["MarkerUdogodnienia"] = "markerStacjaRowerowMiejskich";
    FrameMarkerIcon["MarkerKomunikacja"] = "markerPrzystanekAutobusowy";
    FrameMarkerIcon["MarkerRekreacja"] = "markerKultura";
    FrameMarkerIcon["MarkerRozrywkaSport"] = "markerFitness";
    FrameMarkerIcon["MarkerEdukacja"] = "markerSzkola";
    FrameMarkerIcon["MarkerZdrowieUroda"] = "markerSzpital";
    FrameMarkerIcon["MarkerPrzedszkoleZlobek"] = "markerPrzedszkole";
    FrameMarkerIcon["MarkerPunktMedyczny"] = "markerApteka";
    FrameMarkerIcon["MarkerEkologia"] = "markerPark";
    FrameMarkerIcon["MarkerMetro"] = "markerPrzystanekKolejowy";
})(FrameMarkerIcon = exports.FrameMarkerIcon || (exports.FrameMarkerIcon = {}));
//# sourceMappingURL=FrameMarker.types.js.map